module.exports = __webpack_public_path__ + "a2feb9aba20a72f91f67ab55a81e0bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_9-mobile.png
// module id = 136
// module chunks = 1